type RegistrationContext = {
  obcode: string | null;
  referrer: string;
  registrationRedirectUrl: string | null;
  allParams: Record<string, string>;
} | null;

let registrationContext: RegistrationContext = null;

function getRegistrationContext() {
  return registrationContext;
}

function setRegistrationContext(context: RegistrationContext) {
  registrationContext = context;
}

export { getRegistrationContext, setRegistrationContext, type RegistrationContext };
